module.exports = __webpack_public_path__ + "assets/img/thumb-SEOClarity-Landing-Page-+-Website.e02a473a.jpg";